import { JOB_SEARCH_KEY } from "@/config/query-parameter-consts";
import { getProjectTabQueryParam } from "@/features/project";

import { TrackedProcessRun } from "../types/process-provider-types";

export const getJobUrl = ({ tenant, process }: { tenant: string; process: TrackedProcessRun }) => {
  const projectPath = `/${tenant}/projects/${process.project.slug}/`;
  const tabParam = getProjectTabQueryParam("processes");
  const jobParam = `${JOB_SEARCH_KEY}=${process.job.id}`;

  return `${projectPath}?${tabParam}&${jobParam}`;
};
